import React from 'react'
import Input from 'antd/lib/input'

class FieldInput extends React.Component {
  render() {
    return (
      <div className="gw-search__field gw-search__field-input">
        <Input placeholder={this.props.field.label} onChange={this.props.onChange} value={this.props.value} {...this.props.elementProps} />
      </div>
    )
  }
}

export default FieldInput


// WEBPACK FOOTER //
// ./src/components/search/fields/Input.js